// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


export const environment = {
    production: true,
    hmr: false,
       API: 'https://api-br-vdirect.universal-assistance.com/',
  // API: 'https://api-br.universal-assistance.com/',
      TurnstileCaptcha: '0x4AAAAAAANyeLg2YbJzh5mX',

 //   API: 'https://localhost:6001/',
 // TurnstileCaptcha: '1x00000000000000000000AA',

};

    
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thro*/